import {cssTheme} from '@yandex-delivery/blocks/theme'
import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  sourcePlaceMark: css`
    color: ${cssTheme.default.day.textInvert};
  `,
}
